export default __webpack_public_path__ + "static/laptop-bfebd773c05c9cd3e26f30c817c3e1d6.png";